import { pipe } from 'fp-ts/lib/function';
import { parse, success, union } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

import { Id as TransactionIdDecoder } from '../../transaction/Id';

export const Category = iotsUtils.fromList(constants.file.tag.categories);

export const FileType = iotsUtils.fromList(constants.file.tag.fileTypes);

export const MimeType = iotsUtils.fromList(constants.file.tag.mimeTypes);

export const TransactionId = pipe(
	TransactionIdDecoder,
	parse((d) => success(d as typeof constants.file.tag.transactionId))
);

export const Id = union(iotsUtils.fromList(constants.file.tag.ids), TransactionId);
